import { render, staticRenderFns } from "./DatePickerComponent.vue?vue&type=template&id=4b5048ae&scoped=true"
import script from "./DatePickerComponent.vue?vue&type=script&lang=js"
export * from "./DatePickerComponent.vue?vue&type=script&lang=js"
import style0 from "./DatePickerComponent.vue?vue&type=style&index=0&id=4b5048ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5048ae",
  null
  
)

export default component.exports